import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { TgEmoji } from "@/components/TgEmoji";

/**
 * Результат перевірки відгуку (owner 2026-08-11).
 *
 * Два стани: подарунок зараховано або «цього разу не зарахували». Другий текст
 * навмисно без докорів — людина витратила час; кажемо, чого бракує, і лишаємо
 * можливість дописати. Верстка — той самий каркас, що й у GiftOfferModal.
 */
export function FeedbackResultModal({
  useful,
  reason,
  rewarded,
  onClose,
}: {
  useful: boolean;
  reason: string;
  rewarded: boolean;
  onClose: () => void;
}) {
  const navigate = useNavigate();

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm bg-surface rounded-3xl p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Хрестика немає: кнопка нижче вже закриває попап — кнопки не
            дублюють одна одну (owner 2026-09-12). */}

        <div className="text-center mb-4">
          <div className="mb-2 flex justify-center">
            <TgEmoji char={useful ? "💎" : "⏳"} size={48} />
          </div>
          <div className="font-display text-[1.1875rem] font-bold text-ink leading-tight mb-1.5 [text-wrap:balance]">
            {useful ? "Дякуємо — це цінно" : "Цього разу не зарахували"}
          </div>
          <div className="text-[0.8125rem] text-ink-dim leading-relaxed [text-wrap:balance]">
            {useful
              ? "Твій відгук уже в роботі — саме з таких речей ми й будуємо inFLOW далі."
              : reason ||
                "Напиши конкретніше: що саме заважає в роботі та як це виправити."}
          </div>
        </div>

        {rewarded ? (
          <>
            <div className="rounded-2xl bg-primary/[0.06] ring-1 ring-primary/20 p-4 mb-3 text-center">
              <div className="font-mono text-[0.625rem] uppercase tracking-[0.08em] text-ink-dim mb-1">
                Твій подарунок
              </div>
              <div className="font-display text-[1.5rem] font-bold text-primary leading-none">
                14 днів за 1 ₴
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                onClose();
                navigate("/subscription?gift=1");
              }}
              className="w-full rounded-2xl bg-primary text-white py-3 font-display text-[0.875rem] font-semibold active:bg-primary/90 transition"
            >
              Забрати 14 днів
            </button>
            <div className="mt-2 text-center text-[0.6875rem] text-ink-faint [text-wrap:balance]">
              Подарунок чекає в розділі «Підписка» — його не треба вводити.
            </div>
          </>
        ) : (
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-2xl bg-primary text-white py-3 font-display text-[0.875rem] font-semibold active:bg-primary/90 transition"
          >
            {useful ? "Зрозуміло" : "Дописати відгук"}
          </button>
        )}
      </div>
    </div>,
    document.body,
  );
}
